/* eslint-disable */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { crypto } from '@binance-chain/javascript-sdk'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Consumer as WalletConnectClient } from '../context/WalletConnectProvider'
import Icon from '../../components/common/Icon'
import Confirm from '../../components/common/Confirm'
import message from '../../components/common/Message'
import IntervalDate from '../../components/common/IntervalDate'
import NetWork from '../../components/common/NetWork'
import { Button } from '../../components/common/Button'

import { setNeedAuth } from '../../redux/account/action'
import { setTriggerElement } from '../../redux/global/action'
import CancelWhite from '../../static/images/cancelwhite.svg'
import CancelBlack from '../../static/images/cancelblack.svg'
import TestnetSVG from '../../static/images/logo/testnet.svg'
import MainnetSVG from '../../static/images/logo/mainnet.svg'

import { EXPLORER_URL } from '../../utils/httpRequest'
import { downloadKeystore, isUnlockWithWalletConnect } from '../../utils/account'

import { setShowTradePairsMobile } from '../../redux/exchange/action'
import { setWalletConnectURI } from '../../redux/walletConnect/action'
import { setFavorites } from '../../redux/tradePairs/action'

import MenuMobile from '../../components/mobile/MenuMobile'
import ConfirmPasswordModalHost from '../../containers/modals/ConfirmPasswordModalHost'
import zIndex from '../../utils/zIndexScale'
import { isMobile } from '../../utils/bomUtils'
import { NETWORK_ENV } from '../../utils/httpRequest'
import isElectron from '../../utils/isElectron'
import { isTokenManagementEnabled } from '../../utils/isTokenManagementEnabled'

import SelectLang from '../../i18n/containers/SelectLang'
import { withI18n } from '../../i18n/util'

import testnetSvg from '../../static/images/logo/testnet.svg'
import mainnetSvg from '../../static/images/logo/mainnet.svg'
import mobileLogoSvg from '../../static/images/logo/mobile.svg'
import electronLogoSvg from '../../static/images/logo/trubi.svg'

const logoUrl = (() => {
  if (isMobile()) return mobileLogoSvg
  if (isElectron()) return electronLogoSvg
  if (NETWORK_ENV === 'testnet') return testnetSvg
  return mainnetSvg
})()

const Wrapper = styled.div`
  height: 50px;
  line-height: 50px;
  background: ${({ theme, bgColor }) => (bgColor ? bgColor : theme.headerBg)};
  color: ${({ theme }) => theme.fontColor};
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.header};
  @media (max-width: 768px) {
    height: 44px;
    line-height: 44px;
  }
`

const StyledSelectLang = styled.div`
  height: 100%;
  .select {
    vertical-align: middle;
    height: 40px;
    line-height: 40px;
    color: inherit;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const LeftPane = styled.div`
  display: flex;
`

const Logo = styled.div`
  color: #f0b90b;
  max-width: 150px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: -15px;
  padding-left: 15px;

  img {
    max-width: 100%;
    height: 25px;
  }
`

const DateNetWork = styled.div`
  margin-left: 20px;
  padding-top: 10px;
  @media (max-width: 868px) {
    display: none;
  }
`

const RightPane = styled.div`
  justify-content: flex-end;
  display: flex;
  position: absolute;
  right: 15px;
`

const Menu = styled.ul`
  display: flex;
  flex-direction: row;
  li {
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    margin-left: 15px;
    cursor: pointer;
    position: relative;

    &:hover {
      background: ${({ theme }) => theme.headerItemHoverBg};
    }

    a {
      height: 100%;
      display: block;
      color: inherit;
      font-size: 13px;
      &:hover {
        text-decoration: none;
      }
    }
    &:hover ul {
      display: block;
    }
  }
  li.withSubMenus {
    ul {
      color: #fff;
    }

    .triangle {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%) rotate(0deg);
      transition: transform 0.3s ease-in-out;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid currentColor;
    }
    &:hover .triangle {
      transform: translate(0, -50%) rotate(180deg);
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const MobileMenuIcon = styled.div`
  display: none;
  position: relative;
  cursor: pointer;
  width: 20px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 60px;
    top: 0;
    bottom: 0;
    left: -20px;
  }
  @media (max-width: 768px) {
    display: block;
  }
`

const Cycle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color || '#00C087'};
  margin-right: 5px;
`

const UserMenu = styled.ul`
  display: none;
  flex-direction: column;
  color: ${({ theme }) => theme.fontColor};
  position: absolute;
  top: 50px;
  right: 0;
  background: ${({ theme }) => theme.headerDropdownBg};
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);

  li {
    padding: 10px;
    background: ${({ theme }) => theme.headerDropdownBg};
    width: 290px;
    text-align: left;
    height: 20px;
    line-height: 20px;
    text-indent: 10px;
    font-size: 13px;

    &:hover {
      background: ${({ theme }) => theme.headerDropdownItemHoverBg};
    }

    > a {
      height: 100%;
      display: block;
      color: inherit;
      font-size: 13px;

      &:hover {
        text-decoration: none;
      }
    }
  }

  li.wallet-address {
    display: block;
    min-height: 40px;
    height: auto;
    align-items: center;
    background: ${({ theme }) => theme.userMenuAddressBg};
    color: ${({ theme }) => theme.userMenuAddressTextColor};
    position: relative;
    text-indent: 20px;

    .title {
      color: ${({ theme }) => theme.userMenuAddressTextColor};
      width: 100px;
      white-space: nowrap;
    }

    .status {
      position: absolute;
      top: 15px;
      left: 10px;
    }

    .address {
      width: 220px;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      color: ${({ theme }) => theme.fontColor};
    }

    .op {
      position: absolute;
      right: 15px;
      top: 30px;

      i {
        margin-right: 10px;

        &:hover {
          color: ${({ theme }) => theme.highlight};
        }
      }

      span {
        position: relative;
      }

      span.address {
        margin-right: 10px;
      }
    }
  }
`

const UserInfo = styled.div`
  width: 52px;
  text-align: center;
  cursor: pointer;
  position: relative;

  &:hover {
    background: ${({ theme }) => theme.headerDropdownBg};
  }

  .status {
    position: absolute;
    right: 10px;
    bottom: 20px;
  }

  ul li:not(.wallet-address) {
    animation: userappear 0.3s ease-in-out;

    @keyframes userappear {
      0% {
        height: 0;
        opacity: 0;
      }
      40% {
        height: 10px;
        opacity: 0;
      }
      100% {
        height: 20px;
        opacity: 1;
      }
    }
  }

  &:hover ul {
    display: flex;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100px;
    margin-bottom: 20px;
  }
`

const CancelImg = styled.div`
  width: 100px;
  height: 66px;
  background: ${({ theme }) =>
    theme.mode === 'DARK' ? `url(${CancelBlack})` : `url(${CancelWhite})`};
  background-size: contain;
`

const SubMenus = styled.ul`
  display: none;
  position: absolute;
  top: 50px;
  right: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  background: ${({ theme }) => theme.headerDropdownBg};

  li {
    background: ${({ theme }) => theme.headerDropdownBg};
    color: ${({ theme }) => theme.fontColor};
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    white-space: nowrap;
    animation: appear 0.3s ease-in-out;
    margin-left: 0;

    &:hover {
      background: ${({ theme }) => theme.headerDropdownItemHoverBg};
      color: ${({ theme }) => theme.highlight};
    }

    @media (max-width: 768px) {
      background: inherit;
    }
  }
`

const MobileItemBox = styled.div`
  display: none;
  width: 100%;
  margin-left: 20px;
  color: #fff;
  .trade-pair {
    font-size: 18px;
    position: relative;
    width: fit-content;
    white-space: nowrap;
    /* width: 115px; */
    /* text-overflow: ellipsis; */
    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 40px;
      height: 44px;
      right: -30px;
    }
  }
  .more-trade-pair {
    position: absolute;
    right: -25px;
    top: 0;
  }
  .value {
    margin-left: 8px;
    width: 60px;
    text-align: left;
    white-space: nowrap;
  }
  @media (max-width: 768px) {
    display: block;
  }
  @media (max-width: 319px) {
    display: none;
  }
  @media (max-width: 350px) {
    .trade-pair {
      font-size: 14px;
    }
    .more-trade-pair {
      right: -20px;
    }
  }
`

const SearchWrap = styled.div`
  position: absolute;
  top: 0;
  right: 50px;
`

const ReconnectButton = styled(Button)`
  width: 255px;
  height: 30px;
  line-height: 30px;
  color: #212833;
  margin: 20px 0 20px 20px;
`

const GoToExplorer = styled.a`
  color: currentColor;
  text-decoration: none;

  :hover {
    text-decoration: none;
  }
`

const FavoriteIcon = styled.div`
  display: none;
  cursor: pointer;
  width: 20px;
  top: 0px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 60px;
    top: 0;
    bottom: 0;
    left: -20px;
  }
  @media (max-width: 768px) {
    display: block;
  }
`

class Header extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    privateKey: PropTypes.string,
    address: PropTypes.string,
    encryptedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    currentTrade: PropTypes.string,
    cipher: PropTypes.string,
    needAuth: PropTypes.bool,
    withOpenOrders: PropTypes.bool,
    withTradePairs: PropTypes.bool,
    history: PropTypes.object.isRequired,
    formatI18nText: PropTypes.func,
    bgColor: PropTypes.string,
    isIpValid: PropTypes.bool,
    isConnectedWithWallet: PropTypes.bool,
  }

  static defaultProps = {
    dispatch: () => {},
    privateKey: '',
    address: '',
    encryptedData: null,
    currentTrade: '',
    cipher: '',
    needAuth: false,
    withOpenOrders: true,
    withTradePairs: false,
    formatI18nText: () => {},
    bgColor: '',
    isIpValid: true,
    isConnectedWithWallet: false,
  }

  state = {
    dateTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    confirmLogout: false,
    showMobileMenu: false,
    showSearchIcon: false,
    menus: [
      { text: 'Exchange', i18nId: 'header.exchange', path: '/trade' },
      {
        text: 'Orders',
        i18nId: 'header.orders',
        subMenus: [
          { text: 'Open Orders', i18nId: 'header.openOrders', path: '/openOrders' },
          { text: 'Order History', i18nId: 'header.orderHistory', path: '/orderHistory' },
          { text: 'Trade History', i18nId: 'header.tradeHistory', path: '/tradeHistory' },
          { text: 'Fee History', i18nId: 'header.feeHistory', path: '/feeHistory' },
        ],
      },
      { text: 'Transactions', i18nId: 'header.transactions', path: '/transactionHistory' },
      { text: 'Balances', i18nId: 'header.balances', path: '/balances' },
    ],
  }

  componentDidMount() {
    const {
      match: { path },
    } = this.props
    this.setState({ showSearchIcon: path[0] === '/:locale/' })
  }

  componentWillUnmount() {
    this.dateTimeHandler && clearInterval(this.dateTimeHandler)
  }

  _confirmSignout = wcClient => () => {
    if (isUnlockWithWalletConnect()) {
      wcClient && wcClient.disconnect()
    }
    const { history, locale } = this.props
    sessionStorage.removeItem('user')
    window.localStorage.removeItem('walletconnect')
    // window.location.reload()
    if (isElectron()) {
      window.location.reload()
    } else {
      history.push(`/${locale}/unlock`)
    }
  }

  _copyAddress = () => {
    const { formatI18nText } = this.props
    message.info(formatI18nText('header.user.copySuccess'))
  }

  _exportKeyStore = ev => {
    const { dispatch, privateKey, cipher, needAuth } = this.props
    if (!needAuth) {
      dispatch(setNeedAuth(true))
      dispatch(setTriggerElement(ev.currentTarget))
      this.setState({ showInputPassword: true })
    }

    if (needAuth && privateKey) {
      const keyStore = crypto.generateKeyStore(privateKey, cipher)
      downloadKeystore(keyStore)
      this.setState({ showInputPassword: false })
    }
  }

  _getMenus = () => {
    const { withOpenOrders, address, locale } = this.props
    const subMenus = [
      { text: 'Order History', i18nId: 'header.orderHistory', path: `/${locale}/orderHistory` },
      { text: 'Trade History', i18nId: 'header.tradeHistory', path: `/${locale}/tradeHistory` },
    ]

    if (withOpenOrders) {
      subMenus.unshift({
        text: 'Open Orders',
        i18nId: 'header.openOrders',
        path: `/${locale}/openOrders`,
      })
    }

    subMenus.push({
      text: 'Fee History',
      i18nId: 'header.feeHistory',
      path: `/${locale}/feeHistory`,
    })

    let loginedMenus = [
      {
        text: 'Transactions',
        i18nId: 'header.transactions',
        path: `/${locale}/transactionHistory`,
      },
      { text: 'Balances', i18nId: 'header.balances', path: `/${locale}/balances` },
    ]

    if (!isTokenManagementEnabled) {
      loginedMenus.unshift({ text: 'Orders', i18nId: 'header.orders', subMenus: subMenus })
      loginedMenus.unshift({
        text: 'Exchange',
        i18nId: 'header.exchange',
        path: `/${locale}/trade`,
      })
    }

    if (isTokenManagementEnabled && isElectron()) {
      loginedMenus.push({ text: 'Tokens', i18nId: 'Tokens', path: `/${locale}/tokens` })
    }

    const unLoginedMenus = []

    if (!isTokenManagementEnabled) {
      unLoginedMenus.push({ text: 'Exchange', i18nId: 'header.exchange', path: `/${locale}/trade` })
    }

    unLoginedMenus.push({
      text: 'Create New Wallet',
      i18nId: 'header.createWallet',
      path: `/${locale}/create`,
    })
    unLoginedMenus.push({
      text: 'Unlock Wallet',
      i18nId: 'header.unlockWallet',
      path: `/${locale}/unlock`,
    })

    return address ? loginedMenus : unLoginedMenus
  }

  _showMobileMenu = () => {
    this.setState({ showMobileMenu: true })
  }

  _hideMobileMenu = () => {
    this.setState({ showMobileMenu: false })
  }

  _showTradepairs = () => {
    const { dispatch } = this.props
    dispatch(setShowTradePairsMobile(true))
  }

  _showConfirmLogout = () => {
    this.setState({ confirmLogout: true })
  }

  _clickLogo = () => {
    const { locale } = this.props
    if (!isElectron()) {
      window.location.href = `/${locale}`
    }
  }

  _reConnect = walletConnectClient => async () => {
    try {
      const { dispatch } = this.props
      window.localStorage.removeItem('walletconnect')
      const uri = await walletConnectClient.startSession(false)
      if (__DEV__) {
        console.log('WalletConnect URI', uri)
      }
      dispatch(setWalletConnectURI(uri))
    } catch (err) {
      // window.location.reload()
      if (__DEV__) {
        console.log(err)
      }
    }
  }

  _getFavoriteIcon = () => {
    const { currentTrade, favorites } = this.props
    const isInFavorites = !!favorites?.find(f => currentTrade.replace('_', '/') === f)
    return isInFavorites ? 'starfilled' : 'staroutlined'
  }

  _addFavorite = () => {
    const { favorites, dispatch, currentTrade } = this.props
    const key = currentTrade.replace('_', '/')
    if (!favorites?.find(f => f === key)) {
      favorites.push(key)
    } else {
      for (let i = 0, len = favorites.length; i < len; i++) {
        if (favorites[i] === key) {
          favorites.splice(i, 1)
        }
      }
    }

    dispatch(setFavorites(favorites))
  }

  render() {
    const { confirmLogout, showMobileMenu, showSearchIcon } = this.state

    const {
      flags: { isLedger, isTrezor, isCoinomi, isInfinito, isWalletConnect },
      address,
      encryptedData,
      currentTrade,
      withTradePairs,
      className,
      formatI18nText,
      locale,
      bgColor,
      isIpValid,
      isConnectedWithWallet,
    } = this.props

    const pair = currentTrade.split('_')
    const menus = this._getMenus()
    const menusElements = menus.map(menu => {
      if (menu.subMenus) {
        return (
          <li className="withSubMenus" key={menu.text}>
            <span>{formatI18nText(menu.i18nId)}</span>
            <SubMenus className="subMenus">
              {menu.subMenus.map((sm, index) => {
                return (
                  <li key={sm.text}>
                    <Link to={sm.path}>{formatI18nText(sm.i18nId)}</Link>
                  </li>
                )
              })}
            </SubMenus>
            <i className="triangle" />
          </li>
        )
      } else {
        return (
          <li key={menu.text}>
            <Link to={menu.path}>
              <span>{formatI18nText(menu.i18nId)}</span>
            </Link>
          </li>
        )
      }
    })

    const walletConnectStatus = isConnectedWithWallet ? '#00C087' : '#F23051'
    const favoriteIcon = this._getFavoriteIcon()

    return (
      <WalletConnectClient>
        {wcClient => (
          <Wrapper className={className} bgColor={bgColor}>
            <LeftPane>
              <Logo onClick={this._clickLogo}>
                <img src={logoUrl} alt="" />
              </Logo>
              {!isMobile() && (
                <DateNetWork>
                  <IntervalDate />
                  <NetWork />
                </DateNetWork>
              )}
              {withTradePairs && pair[0] && (
                <MobileItemBox onClick={this._showTradepairs}>
                  <div className="trade-pair">
                    {pair[0].replace(/-[A-F0-9]+/g, '')}
                    {' / '}
                    {pair[1].replace(/-[A-F0-9]+/g, '')}
                    <div className="more-trade-pair" onClick={this._showTradepairs}>
                      <Icon type="sanjiaojiantouxia-B" color="#f0b90b" />
                    </div>
                  </div>
                </MobileItemBox>
              )}
              {withTradePairs && (
                <FavoriteIcon onClick={this._addFavorite}>
                  <Icon type={favoriteIcon} color="#f0b90b" size={20} />
                </FavoriteIcon>
              )}
            </LeftPane>
            <RightPane>
              <Menu>
                <li>
                  <a href={EXPLORER_URL} {...(isElectron() ? { target: '_blank' } : {})}>
                    {formatI18nText('header.explorer')}
                  </a>
                </li>
                {menusElements}
              </Menu>
              {address && (
                <UserInfo>
                  <Icon type="account" size={22} />
                  {isWalletConnect && <Cycle className="status" color={walletConnectStatus} />}
                  <UserMenu>
                    <li className="wallet-address">
                      <div>
                        {isWalletConnect && (
                          <Cycle className="status" color={walletConnectStatus} />
                        )}
                        <div className="title">
                          {isLedger ? formatI18nText('header.user.ledger') : ''}
                          {isTrezor ? formatI18nText('header.user.trezor') : ''}
                          {isCoinomi ? formatI18nText('header.user.coinomi') : ''}
                          {isInfinito ? formatI18nText('header.user.infinito') : ''}
                          {isWalletConnect ? formatI18nText('header.user.walletConnect') : ''}
                          &nbsp;
                          {formatI18nText('header.user.wallet')}
                        </div>
                        <div className="address">{address}</div>
                      </div>
                      <div className="op">
                        <CopyToClipboard text={address} onCopy={this._copyAddress}>
                          <span title={formatI18nText('header.user.copyAddress')}>
                            <Icon type="copy" />
                          </span>
                        </CopyToClipboard>
                        <GoToExplorer
                          href={`${EXPLORER_URL}/address/${address}`}
                          target="_blank"
                          title={formatI18nText('header.user.goToExplorer')}
                        >
                          <Icon type="link" />
                        </GoToExplorer>
                      </div>
                      {isWalletConnect && !isConnectedWithWallet && (
                        <ReconnectButton onClick={this._reConnect(wcClient)}>
                          <span>Reconnect</span>
                        </ReconnectButton>
                      )}
                    </li>
                    <li>
                      <Link to={`/${locale}/unlock`}>
                        {formatI18nText('header.user.changeWallet')}
                      </Link>
                    </li>
                    <li>
                      <Link to={`/${locale}/create`}>
                        {formatI18nText('header.user.createNewWallet')}
                      </Link>
                    </li>
                    {encryptedData && encryptedData !== 'HARDWARE' && (
                      <li onClick={this._exportKeyStore}>
                        {formatI18nText('header.user.exportKeystoreFile')}
                      </li>
                    )}
                    <li onClick={this._showConfirmLogout}>
                      {formatI18nText('header.user.closeWallet')}
                    </li>
                  </UserMenu>
                </UserInfo>
              )}
              <StyledSelectLang>
                <SelectLang overlayClassName="header-dropdown-overlay" />
              </StyledSelectLang>
              {!isElectron() && (
                <Menu>
                  <li className="withSubMenus">
                    <Icon type="detail-D" />
                    <SubMenus className="subMenus">
                      <li>
                        <a href="https://docs.binance.org/">{formatI18nText('header.faq')}</a>
                      </li>
                      <li>
                        <a href="https://community.binance.org/">
                          {formatI18nText('header.forums')}
                        </a>
                      </li>
                      {NETWORK_ENV === 'mainnet' ? (
                        <li>
                          <a href="https://testnet.binance.org">
                            {formatI18nText('header.testnet')}
                          </a>
                        </li>
                      ) : (
                        <li>
                          <a href="https://www.binance.org">{formatI18nText('header.mainnet')}</a>
                        </li>
                      )}
                      <li>
                        <Link to={`/${locale}/tokens`}>
                          {formatI18nText('token.main.issueToken')}
                        </Link>
                      </li>
                    </SubMenus>
                  </li>
                </Menu>
              )}
              <MobileMenuIcon onClick={this._showMobileMenu}>
                <Icon type="menu" size={20} />
              </MobileMenuIcon>
              {isMobile() && showSearchIcon && (
                <SearchWrap onClick={this._showTradepairs}>
                  <Icon type="search" color="#828A98" size="24" />
                </SearchWrap>
              )}
            </RightPane>
            {showMobileMenu && (
              <MenuMobile
                address={address}
                close={this._hideMobileMenu}
                closeWallet={this._showConfirmLogout}
                isIpValid={isIpValid}
              />
            )}
            {confirmLogout && (
              <Confirm
                cancelText={formatI18nText('common.cancel')}
                okText={formatI18nText('common.confirm')}
                confirm={this._confirmSignout(wcClient)}
                cancel={() => {
                  this.setState({ confirmLogout: false })
                }}
              >
                <ConfirmContent>
                  <CancelImg />
                  <p>{formatI18nText('header.youWantCloseWallet')}</p>
                </ConfirmContent>
              </Confirm>
            )}
            {/* !isMobile() &&
                <Notifycation /> */}
            <ConfirmPasswordModalHost />
          </Wrapper>
        )}
      </WalletConnectClient>
    )
  }
}

const mapStateToProps = ({
  account: { privateKey, needAuth, address, encryptedData, cipher, flags },
  exchange: { currentTrade },
  globalData: { isIpValid },
  walletConnect: { isConnectedWithWallet },
  tradePairs: { favorites },
}) => ({
  needAuth,
  privateKey,
  address,
  encryptedData,
  cipher,
  currentTrade,
  flags,
  isIpValid,
  isConnectedWithWallet,
  favorites,
})

export default withI18n(connect(mapStateToProps)(withRouter(Header)))
